<template>
  <keep-alive include="TermsList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Terms",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
